export const urlAuth = `${process.env.VUE_APP_API_AUTH_URL}/auth`;
export const urlAfip = `${process.env.VUE_APP_API_URL}/afip`;
export const urlFlujoArt = `${process.env.VUE_APP_API_URL}/flujoart`;
export const urlInitial = `${process.env.VUE_APP_API_URL}/initial`;
export const urlBsa = `${process.env.VUE_APP_API_URL}/bsa`;
export const urlPoliza = `${process.env.VUE_APP_API_URL}/poliza`;
export const urlMail = `${process.env.VUE_APP_API_MAIL_URL}`;
export const urlFiles = `${process.env.VUE_APP_API_URL}/loadFile`;
export const urlEmpresa = `${process.env.VUE_APP_API_URL}/empresa`;
export const urlFlujoAgro = `${process.env.VUE_APP_API_URL}/flujoagro`;
export const urlAbm = `${process.env.VUE_APP_API_URL}/abm`;
export const urlSiniestro = `${process.env.VUE_APP_API_URL}/siniestro`;
export const urlFrontendApp = `${process.env.VUE_APP_API_URL_ITEVO}`;
export const urlCaucion = `${process.env.VUE_APP_API_URL}/flujocaucion`;
export const urlReporte = `${process.env.VUE_APP_API_URL}/reporte`;
export const urlLogs = `${process.env.VUE_APP_API_URL}/logs`;
export const urlFlujoAutomotor = `${process.env.VUE_APP_API_URL}/flujoautomotor`;
export const urlClient = `${process.env.VUE_APP_API_URL}/client`;
export const urlMailBackend = `${process.env.VUE_APP_API_URL}/mail`;
export const urlHipoteca = `${process.env.VUE_APP_API_URL}/flujohipoteca`;
export const urlResponsabilidadCivil = `${process.env.VUE_APP_API_URL}/flujoresponsabilidadcivil`;
export const urlMailResponsabilidadCivil = `${process.env.VUE_APP_API_URL}/mail/sendResponsabilidadCivilEmail`;
export const emailConsulta = process.env.VUE_APP_MAIL_CONSULTA;
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
export const GOOGLE_MAPS_MAP_ID = process.env.VUE_APP_GOOGLE_MAPS_MAP_ID;

export function createResetStateMutation(getInitialStateFn) {
   // Función que devuelve una función que resetea el estado de un módulo
   return function resetState(state) {
      Object.assign(state, getInitialStateFn());
   };
}

export const convertToFiles = (files) => {
   if (!files) return;
   return files
      .map((fileObj) => {
         try {
            // Si viene Base64 (compatibilidad hacia atrás)
            if (fileObj.file) {
               const base64Content = fileObj.file;
               const mimeType = 'application/pdf';
               const byteCharacters = atob(base64Content);
               const byteNumbers = new Array(byteCharacters.length)
                  .fill(null)
                  .map((_, i) => byteCharacters.charCodeAt(i));
               const byteArray = new Uint8Array(byteNumbers);
               const file = new File([byteArray], fileObj.name, {
                  type: mimeType,
               });
               return {
                  file,
                  base64: base64Content,
                  id_file: fileObj.hashId,
                  hashId: fileObj.hashId,
                  esCotizacion: fileObj.esCotizacion,
                  compania: fileObj.compania ? fileObj.compania : null,
                  name: fileObj.name,
               };
            }

            // Solo metadatos (nuevo comportamiento)
            return {
               id_file: fileObj.hashId,
               hashId: fileObj.hashId,
               esCotizacion: fileObj.esCotizacion,
               compania: fileObj.compania ? fileObj.compania : null,
               name: fileObj.name,
               file: null, // Mantener compatibilidad
               base64: null, // Mantener compatibilidad
            };
         } catch (error) {
            console.error(
               `Error al procesar el archivo: ${fileObj.name}`,
               error,
            );
            return null;
         }
      })
      .filter((entry) => entry !== null);
};

export { formatClienteNombreCompleto } from './formatClienteNombre';
